/**
 * @fileoverview Vuex module for live chat management.
 *
 * @module store/modules/livechat
 *
 * Combines actions, getters, mutations, and state for live chat features
 * including queue management, agent assignment, messaging, and chat history.
 */

import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import state from "./state";
import { Module } from "vuex/types";
import { LivechatState } from "./types";
import { RootState } from "@/store/types";

const livechat: Module<LivechatState, RootState> = {
  // namespaced: true,
  actions,
  getters,
  mutations,
  state,
};

export default livechat;
